import { render, staticRenderFns } from "./AwardsTable.vue?vue&type=template&id=5d9e7f1d"
import script from "./AwardsTable.vue?vue&type=script&lang=js"
export * from "./AwardsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports